import React, { useEffect } from "react";
import { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { Avatar, Button } from "@mui/material";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import apiClient from "../api/apiClient";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import { getCurrentURLParameters } from "../modules/helpers";
import LoadingSpinner from "../components/LoadingSpinner";

const UserDetail = () => {
  const { id } = getCurrentURLParameters();

  const { profiledata, fetchDataprofile } = useIndexPageData();
  const [avatarSrc, setAvatarSrc] = useState("");
  // const [selectedOption, setSelectedOption] = useState('');
  const [Edit, setEdit] = useState(false);
  const [loader, setloader] = useState(false);
  const [profileupdate, setprofileupdate] = useState([]);

  //   const handleOptionChange = (event) => {
  //     setSelectedOption(event.target.value);
  //   };

  //   const[profileupdate,setprofileupdate]=useState({full_name:"",email:"",profile:""})
  const handleonchange = (key, value) => {
    setprofileupdate((pre) => ({ ...pre, [key]: value }));
  };

  // const handleUploadClick = (event) => {
  //     const file = event.target.files[0];
  //     const reader = new FileReader();
  //     handleonchange("profile",file)

  //     reader.onloadend = () => {
  //       setAvatarSrc(reader.result);
  //     };

  //     if (file) {
  //       reader.readAsDataURL(file);
  //     }
  //   };
  //   const postprofiledata = async (e) => {
  //     e.preventDefault(); // Prevent default form submission behavior

  //     // Assuming profileupdate is defined elsewhere in your code
  //     const formData = new FormData();
  //     formData.append('full_name', profileupdate.full_name);
  //     formData.append('email', profileupdate.email);
  //     if(typeof profileupdate.profile=="object" && profileupdate.profile ){

  //         formData.append('profile', profileupdate.profile);
  //     }

  //     if (!userid) return;

  //     try {
  //         setloader(true)
  //         const result = await apiClient.put(`/register/${userid}/`, formData);
  //         setloader(false)
  //         if (result.ok) {
  //             fetchDataprofile()
  //             toast.success("Profile updated successfully");
  //         } else {
  //         }
  //     } catch (error) {
  //         console.error("Error updating profile:", error.message);
  //     }
  // };

  //   useEffect(()=>{

  //     setprofileupdate(profiledata)

  //  },[profiledata.full_name])

  useEffect(() => {
    const fetch = async () => {
      setloader(true);
      const result = await apiClient.get(`/register/${id}/`);
      setloader(false);
      if (result.ok) setprofileupdate(result?.data);
    };
    fetch();
  }, []);
  return (
    <>
      <section className=" mb-5 ">
        <div className="container">
          {loader ? (
            <div className="d-flex justify-content-center mt-5">
              <LoadingSpinner color="#FF3E1F" />
            </div>
          ) : (
            <form className="row">
              <div className="col-md-12">
                <h3 className="fw-normal mb-3">User Information</h3>
                <div
                  className="p-4 mx-3"
                  style={{ backgroundColor: "#F9FBFA", borderRadius: "44px" }}
                >
                  <div>
                    <div className="d-flex gap-3 mb-3 align-items-center ">
                      <Avatar
                        src={profileupdate.profile}
                        alt="logo"
                        sx={{ width: 56, height: 56 }}
                      />
                      <div>
                        {/* <h5 className='mb-1'>Upload your profile photo:</h5> */}
                        {/* <input
                                    hidden
                                        accept="image/*"
                                        // style={{ display: 'none' }}
                                        id="1"
                                        type="file"
                                        onChange={handleUploadClick}
                                    /> */}
                        {/* <label htmlFor="1">
                                        <div className='btn grey-btn'>Upload</div>
                                    </label> */}
                      </div>
                    </div>

                    {/* <div className='d-flex mb-3 gap-2 '>
                                    <CiEdit style={{color:"#000" , fontSize:"22px"}} />
                                    <div>
                                        <h5 className='fw-bold mb-1'>Active Credit card</h5>
                                        <p className='mb-2'>**** **** **** 1234</p>
                                    </div>
                                </div> */}

                    <div className="d-flex mb-3 gap-2 ">
                      {/* <CiEdit style={{color:"#000" , fontSize:"20px"}} onClick={()=>setEdit(!Edit)} /> */}
                      <div>
                        <h5 className="fw-bold mb-1">Name</h5>

                        {!Edit ? (
                          <p className="mb-2">{profileupdate?.full_name} </p>
                        ) : (
                          <input
                            className="form-control"
                            onChange={(e) =>
                              handleonchange("full_name", e.target.value)
                            }
                            style={{ background: "none" }}
                            type="text"
                            value={profileupdate?.full_name}
                          />
                        )}
                      </div>
                    </div>

                    <div className="d-flex mb-3 gap-2 ">
                      {/* <CiEdit style={{color:"#000" , fontSize:"20px"}} onClick={()=>setEdit(!Edit)} /> */}
                      <div>
                        <h5 className="fw-bold ">Email</h5>
                        {!Edit ? (
                          <p className="mb-2">{profileupdate?.email}</p>
                        ) : (
                          <input
                            className="form-control"
                            onChange={(e) =>
                              handleonchange("email", e.target.value)
                            }
                            style={{ background: "none" }}
                            type="text"
                            value={profileupdate?.email}
                          />
                        )}
                        {/* <label className='d-block'>
                                            <input
                                            type="radio"
                                            value="option1"
                                            checked={selectedOption === 'option1'}
                                            onChange={handleOptionChange}
                                            className='me-1 mt-1'
                                            />
                                            I agree to
                                            recieve emails from Mockee
                                        </label> */}
                        {/* <label className='d-block'>
                                            <input
                                            type="radio"
                                            value="option2"
                                            checked={selectedOption === 'option2'}
                                            onChange={handleOptionChange}
                                            />
                                            I'm a Business Owner
                                        </label> */}
                      </div>
                    </div>

                    {/* <div className='d-flex mb-3 gap-2 '>
                                    <CiEdit style={{color:"#000" , fontSize:"20px"}} />
                                    <div>
                                        <h5 className='fw-bold '>Company name</h5>
                                        <p className='mb-2'>Alex Enterprise</p>
                                    </div>
                                </div>

                                <div className='d-flex mb-3 gap-2 '>
                                    <CiEdit style={{color:"#000" , fontSize:"20px"}} />
                                    <div>
                                        <h5 className='fw-bold '>Company Adress</h5>
                                        <p className='mb-2'>Imagine Street 6666.</p>
                                    </div>
                                </div> */}

                    {/* <div className='d-flex mb-3 gap-2 '>
                                    <CiEdit style={{color:"#000" , fontSize:"20px"}} />
                                    <div>
                                        <h5 className='fw-bold '>Tax Id</h5>
                                        <p className='mb-2'>GB6666</p>
                                    </div>
                                </div> */}

                    {/* <div className="d-flex justify-content-center ">

                            
                                  <Button onClick={postprofiledata}
                                  disabled={loader}
                                  type='submit'
              variant="contained"
              className="login-btn"
            
              component="a"
            
              sx={{ padding: '6px 29px 7px',fontSize:"15px" , borderRadius: '8px' , backgroundColor: '#C93312' ,
              '&:hover': {
                  backgroundColor: '#C93312',
                  opacity: '0.9'
              },
               textTransform: 'none'
          
          }}
        
           
            >
           {loader?  "Submit...":"Submit"}
            </Button>
                        </div> */}
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </section>
    </>
  );
};

export default UserDetail;
